import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useGTMRouteTracking } from '../utils/gtm.utils';

/**
 * Component to track route changes for GTM
 * This component should be placed in the main App component
 */
const GTMRouteTracker: React.FC = () => {
  const location = useLocation();
  const { trackRouteChange } = useGTMRouteTracking();

  useEffect(() => {
    // Track route change when location changes
    trackRouteChange(location.pathname, location.search);
  }, [location, trackRouteChange]);

  // This component doesn't render anything
  return null;
};

export default GTMRouteTracker; 